export const landingsKeys = {
  property: {
    leadType: 'SALE',
    title: 'getSelection',
    sourceForm: 'property_request_call_first_screen',
  },
  apartments: {
    leadType: 'SALE',
    title: 'getIndividualSelection',
    sourceForm: 'apartments_request_call_first_screen',
  },
  investments: {
    leadType: 'SALE',
    title: 'getOffer',
    sourceForm: 'request_invest_portfolio',
  },
  management: {
    leadType: 'PROPERTY_MANAGEMENT',
    title: 'transferObject',
    sourceForm: 'hand_over_first_screen',
  },
  rent: {
    leadType: 'RENT',
    title: 'orderSelection',
    sourceForm: 'hand_over_first_screen',
  },
} as const;

export const normalDelay = 3000;
export const largeDelay = 10000;
export type Delay = typeof normalDelay | typeof largeDelay | null;
